<template>
    <va-create-layout>
        <Marketplace-form :title="title" :item="item"></Marketplace-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
